import React, { useState, useCallback } from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/auth";
import AppRoutes from "./routes/AppRoutes";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Définit le défilement en haut de la page
  }, [pathname]); // S'exécute à chaque changement de route

  return null; // Ce composant n'affiche rien
};

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = useCallback((state) => {
    setIsMenuOpen(state);
  }, []);

  const menuState = {
    isMenuOpen,
    onMenuToggle: handleMenuToggle,
    setIsMenuOpen,
  };

  return (
    <BrowserRouter>
    <ScrollToTop />
      <AuthProvider>
        <Toaster position='top-center' />
        <AppRoutes menuState={menuState} />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
